/** @prettier */

import React from 'react';
import PropTypes from 'prop-types';
import LinesEllipsis from 'react-lines-ellipsis';
import Scrollbar from '@surfline/quiver-react/dist/Scrollbar';
import { withDevice } from '@surfline/quiver-react';
import featuredContentPropType from '../../propTypes/featuredContent';
import devicePropType from '../../propTypes/device';

const FeaturedContent = ({
  featuredContent: { articles },
  device: { width },
  doTrackEvent,
  spotName,
  spotId,
}) => (
  <div className="sl-featured-content">
    <Scrollbar speed={18} style={{ height: '100%', padding: '0 18px' }}>
      <h3>Featured Content</h3>
      <div id="sl-featured-content__articles" className="sl-featured-content__articles">
        {articles.map(article => (
          <a
            key={article.id}
            href={article.permalink}
            className="sl-featured-content__articles__article"
            onClick={() =>
              doTrackEvent('Clicked Spot Page Feed Link', {
                title: article.content.title,
                contentType: article.contentType,
                contentId: article.id,
                tags: article.tags,
                destinationUrl: article.permalink,
                spotName,
                spotId,
              })
            }
          >
            <img
              src={article.media.feed1x || article.media.promobox1x}
              alt={article.content.title}
            />
            <div className="sl-featured-content__articles__article__info">
              <span className="sl-featured-content__articles__article__info__content-type">
                {article.tags[0].name}
              </span>
              <h4>
                {width ? (
                  <LinesEllipsis
                    className="sl-featured-content__articles__article__info__title"
                    text={article.content.title}
                    maxLine={2}
                    ellipsis="..."
                    basedOn="words"
                    winWidth={width}
                    style={{
                      width: width > 975 ? 188 : width - 160,
                      fontSize: 14,
                      fontWeight: 500,
                      whiteSpace: 'pre-wrap',
                    }}
                  />
                ) : null}
              </h4>
            </div>
          </a>
        ))}
      </div>
    </Scrollbar>
  </div>
);

FeaturedContent.propTypes = {
  featuredContent: featuredContentPropType.isRequired,
  device: devicePropType.isRequired,
  doTrackEvent: PropTypes.func.isRequired,
  spotName: PropTypes.string.isRequired,
  spotId: PropTypes.string.isRequired,
};

export default withDevice(FeaturedContent);
